import React from 'react';
import { Image, Text, View } from 'react-native';

import { BACKGROUND_COLOR } from '../constants/Colors';
import { usePFPGeneratorContext } from '../contexts/PFPGeneratorContext';
import { VerticalSpacer20 } from './Spacers';
import TextButton from './TextButton';

export default () => {
  const { mobileDevicePFPImageDataUri, setMobileDevicePFPImageDataUri } =
    usePFPGeneratorContext();

  return (
    <View
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: BACKGROUND_COLOR,
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
      }}
    >
      <View
        style={{
          padding: 20,
          alignItems: 'center',
          width: '100%',
          maxWidth: 840,
        }}
      >
        <Image
          source={{
            uri: mobileDevicePFPImageDataUri,
          }}
          style={{ width: '100%', aspectRatio: 1 }}
        />
        <VerticalSpacer20 />
        <Text style={{ color: 'white', fontSize: 20 }}>
          Long press to save to your device.
        </Text>
        <VerticalSpacer20 />
        <TextButton
          title="Close"
          onPress={() => setMobileDevicePFPImageDataUri(null)}
        />
      </View>
    </View>
  );
};
